/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import SlotStatus from '@linc-technologies/linced-common/enums/bookings/event-slot-status';
import type Allocation from '@linc-technologies/linced-common/models/bookings/allocation';
import type Event from '@linc-technologies/linced-common/models/bookings/event';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: bookings.Slot.
export default class Slot extends Model {
  declare [Type]: 'bookings/slot';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // eventId is the id of the event.
  @belongsTo('bookings/event', { async: true, inverse: 'slots' })
  declare eventId: AsyncBelongsTo<Event>;

  @alias('eventId')
  declare event: AsyncBelongsTo<Event>;

  // Date is a string representation of the slot date
  @attr('string')
  declare date: string | undefined;

  // time is the time of the slot in seconds from the epoch.
  @attr('number')
  declare time: number | undefined;

  // status is the current status of the slot.
  @attr('number', { defaultValue: 0 })
  declare status: number;

  // schoolId is the school the booking relates to.
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  // campusId is the school campus the booking relates to.
  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @hasMany('bookings/allocation', { async: true, inverse: 'slotId' })
  declare allocations: AsyncHasMany<Allocation>;

  @computed('status', 'inProgress')
  get chipStyle() {
    // TS-BUG: Slot has no inProgress property, so this is always false.
    if ((this as Slot & { inProgress?: boolean }).inProgress) {
      return 'booking-status-reserved';
    }
    if (this.status === SlotStatus.UNAVAILABLE) {
      return 'booking-status-blocked';
    }
    return 'booking-status-available';
  }
}
